import { render, staticRenderFns } from "./StudyPlansTable.vue?vue&type=template&id=6aa0940a&scoped=true&"
import script from "./StudyPlansTable.vue?vue&type=script&lang=js&"
export * from "./StudyPlansTable.vue?vue&type=script&lang=js&"
import style0 from "./StudyPlansTable.vue?vue&type=style&index=0&id=6aa0940a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0940a",
  null
  
)

export default component.exports